/* global EventBus */

const onLogin = handler => EventBus.$on('auth:login', handler)
const emitLogin = payload => EventBus.$emit('auth:login', payload)

const onLogout = handler => EventBus.$on('auth:logout', handler)
const emitLogout = payload => EventBus.$emit('auth:logout', payload)

const onChecking = handler => EventBus.$on('auth:checking', handler)
const emitChecked = payload => EventBus.$emit('auth:checking', payload)

const onUpdateUser = handler => EventBus.$on('user:update', handler)
const emitUpdateUser = payload => EventBus.$emit('user:update', payload)

export { onLogin, emitLogin, onLogout, emitLogout, onChecking, emitChecked, onUpdateUser, emitUpdateUser }
